module.exports = __webpack_public_path__ + "img/R.cef0599.jpg";